import type { Participant } from '@piccolohealth/pbs-common';
import { ChakraV3, Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { usePermission } from '../../hooks/usePermission';
import { ParticipantTeamMember } from './ParticipantTeamMember';
import { ParticipantTeamMemberManageModal } from './ParticipantTeamMemberManageModal';

interface Props {
  participant: Participant;
  isDisabled?: boolean;
}

export const ParticipantTeamCard = (props: Props) => {
  const { participant } = props;

  const createParticipantUserPermission = usePermission('create', 'participantUser');
  const isDisabled = props.isDisabled || !createParticipantUserPermission;

  const content = P.run(() => {
    if (P.isEmpty(participant.assignedUsers)) {
      return <Empty h='full' title='No team members assigned yet' p={0} />;
    }

    return (
      <>
        {participant.assignedUsers.map((participantUser) => (
          <ParticipantTeamMember key={participantUser.user.id} participantUser={participantUser} />
        ))}
      </>
    );
  });

  return (
    <ChakraV3.Card.Root h='full'>
      <ChakraV3.Card.Header>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Heading size='xl' fontWeight='bold'>
            Team
          </ChakraV3.Heading>
          <ChakraV3.Text fontSize='sm' color='secondary'>
            {`Manage this participant's team members`}
          </ChakraV3.Text>
        </ChakraV3.Stack>
      </ChakraV3.Card.Header>
      <ChakraV3.Card.Body>
        <ChakraV3.Stack gap={6}>
          {content}
          <ChakraV3.Button
            onClick={() =>
              showModal(ParticipantTeamMemberManageModal, {
                participant: participant,
              })
            }
            disabled={isDisabled}
            size='sm'
            variant='subtle'
          >
            <FaPlus />
            Manage team members
          </ChakraV3.Button>
        </ChakraV3.Stack>
      </ChakraV3.Card.Body>
    </ChakraV3.Card.Root>
  );
};
